<app-main-menu></app-main-menu>
<div class="wrapper">
  <div class="page-header">
    <div class="page-header-image"></div>
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-md-6 offset-lg-0 offset-md-3">
            <div class="square square-7" id="square7"></div>
            <div class="square square-8" id="square8"></div>
            <div class="card card-register">
              <div class="card-header">
                <img
                  alt="Card image"
                  class="card-img"
                  src="assets/img/square1.png"
                />
                <h4 class="card-title text-capitalize ml-1">Registro</h4>
              </div>
              <div class="card-body text-white">
                <div class="d-flex justify-content-center align-items-baseline ">
                  <h4 class="mr-1">Paciente</h4>
                  <bSwitch [(ngModel)]="typeUser" name ="typeUser" (click)="handleType()"
                  [switch-on-text]="' '"
                  [switch-off-text]="' '"
                  >
                  </bSwitch>
                  <h4 class="ml-1">Doctor</h4>
                </div>
                <form (ngSubmit)="register()" class="form">
                  <div
                    class="input-group"
                    [ngClass]="{ 'input-group-focus': focus === true }"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-single-02"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Nombre"
                      type="text"
                      (focus)="focus = true"
                      (blur)="focus = false"
                      name="name" 
                      [(ngModel)]="name"
                      required
                    />
                  </div>
                  <div
                    class="input-group"
                    [ngClass]="{ 'input-group-focus': focus1 === true }"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-single-02"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Apellido"
                      type="text"
                      (focus)="focus1 = true"
                      (blur)="focus1 = false"
                      name="lastname" 
                      [(ngModel)]="lastname"
                      required
                    />
                  </div>
                  
                  <div
                    class="input-group"
                    [ngClass]="{ 'input-group-focus': focus4 === true }"
                    *ngIf="typeUser"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-single-02"> </i>
                      </div>
                    </div>
                    <select
                      class="form-control"
                      placeholder="Apellido"
                      type="text"
                      (focus)="focus4 = true"
                      (blur)="focus4 = false"
                      name="typeDoc" 
                      [(ngModel)]="typeDoc"
                      required
                    >
                      <option value="0">Médico General</option>
                      <option value="1">Psicologo</option>
                      <option value="2">Nutricionista</option>
                      <option value="4">Odontólogo</option>
                      <option value="3">Sexual</option>
                    </select>
                  </div>
                  <div
                    class="input-group"
                    [ngClass]="{ 'input-group-focus': focus2 === true }"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-email-85"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Email"
                      type="text"
                      (focus)="focus2 = true"
                      (blur)="focus2 = false"
                      [(ngModel)]="email"
                      name="email" 
                      required
                    />
                  </div>
                  <div
                    class="input-group"
                    [ngClass]="{ 'input-group-focus': focus3 === true }"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-lock-circle"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Password"
                      type="password"
                      (focus)="focus3 = true"
                      (blur)="focus3 = false"
                      [(ngModel)]="password"
                      name="password" 
                      required
                    />
                  </div>
                  <div class="form-check text-left">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" name="tems" [(ngModel)]="terms" required />

                      <span class="form-check-sign"> </span> Aceptar los
                      <a href="javascript:void(0)"> terminos y condiciones </a> .
                    </label>
                  </div>
                  <div class="row flex-column align-items-center my-3">
                    <button [disabled]="!validateForm(email, password) || !terms" type="submit" class="btn btn-info btn-round btn-lg">
                        Registrarme
                    </button>
                    <div class="mb-1">¿Ya tienes una cuenta? <a href="#" routerLink="/login">Inicia Sesión</a></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="register-bg"></div>
        <div class="square square-1" id="square1"></div>
        <div class="square square-2" id="square2"></div>
        <div class="square square-3" id="square3"></div>
        <div class="square square-4" id="square4"></div>
        <div class="square square-5" id="square5"></div>
        <div class="square square-6" id="square6"></div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
